import { INVOICE } from "../types/invoiceReportTypes";
import { TAX_YEAR } from "../types";

export interface IInvoiceReport {
  id?: string;
  invoiceNo?: string;
  refNo?: string;
  invAmount?: number;
  netAmount?: number;
  invoiceDate?: string;
  paidAmount?: number;
  paymentDate?: string;
  tax?: number;
  paid?: boolean;
  discount?: number;
  handlingCharges?: number;
}

const initialState: IInvoiceReport = {
  invoiceNo: "",
  id: "",
};

export const invoiceReportReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case INVOICE.INVOICE_SET_SELECTED:
      return {
        ...state,
        invoiceNo: action.payload.invoiceNo,
        id: action.payload.id,
      };
    case INVOICE.INVOICE_CLEAR_SELECTED:
      return {
        ...state,
        invoiceNo: initialState.invoiceNo,
        id: initialState.id,
      };
    default:
      return state;
  }
};
